import { axios } from '@Root/API'

export const get = payload => {
	return axios.get(`student-engagement/${payload}`)
}
